const contractErrorHandler = () => {
    const parseError = (error) => {
      
      if (!error) return "Unknown error";
  
      if (error.code === "UNSUPPORTED_OPERATION") {
        return "The contract method might be called incorrectly or doesn't exist.";
      }
  
      if (error.reason) {
        return error.reason;
      }
  
      if (typeof error.message === "string") {
        console.log(error)
        return error.message;
      }

      if (error.code === "CALL_EXCEPTION") {
        return "The contract call failed. Check if the user is registered or the method exists.";
      }
  
      return ("An unexpected error occurred - Please try again");
    };
  
    return { parseError };
  };
  
  export default contractErrorHandler;
  